import React, { useCallback } from 'react';
import { ExploreAll, ExternalLink } from '@yme/assets/icons';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { MenuLinkStyled } from '@yme/components/Header/Megamenu/styled';
import { useTouchOnly } from '@yme/hooks/useTouchOnly';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { getIsExternalLink } from '@yme/utils/common';
import { BLANK, SELF } from '@yme/utils/constants';
import { IconStyled, LinkStyled, LinkWrapperStyled, ListTitleStyled, ListWrapperStyled, MegamenuListItemStyled, MegamenuListStyled, } from '../styled';
export function MegaMenuList({ navItems, children, listTitle, menuLink, buttonLabel, isWidthAuto, isMenuStandoutColourEnabled, isRightToLeft, isTwoLevelsView, closeMenuHandler, }) {
    const withButton = Boolean(buttonLabel);
    const isTouchDevice = useTouchOnly();
    const onClickHandler = useCallback(() => {
        if (closeMenuHandler) {
            closeMenuHandler();
        }
    }, [closeMenuHandler]);
    return (React.createElement(ListWrapperStyled, { isTouchDevice: isTouchDevice, isWidthAuto: isWidthAuto, isFullHeight: !withButton, isRightToLeft: isRightToLeft },
        !isTwoLevelsView && (React.createElement(ListTitleStyled, { isTouchDevice: isTouchDevice, isRightToLeft: isRightToLeft, isMenuStandoutColourEnabled: isMenuStandoutColourEnabled }, listTitle)),
        React.createElement(MegamenuListStyled, { isRightToLeft: isRightToLeft }, children ||
            navItems?.map(({ title, link, onClick }) => {
                const isExternalLink = getIsExternalLink(link);
                return (React.createElement(MegamenuListItemStyled, { key: title, isTouchDevice: isTouchDevice, isRightToLeft: isRightToLeft, isLink: true, isSmallItem: true },
                    React.createElement("span", null,
                        React.createElement(MenuLinkStyled, { to: {
                                pathname: link,
                            }, target: isExternalLink ? BLANK : SELF, onClick: () => {
                                onClickHandler();
                                onClick();
                            }, isRightToLeft: isRightToLeft },
                            title,
                            isExternalLink && (React.createElement(SVGIcon, { size: ICON_SIZE.xxs, pathFill: colorCoreBlack900Base, type: ExternalLink }))))));
            })),
        withButton && !isTwoLevelsView && (React.createElement(LinkWrapperStyled, { isTouchDevice: isTouchDevice, isRightToLeft: isRightToLeft },
            React.createElement(LinkStyled, { to: menuLink, onClick: closeMenuHandler },
                React.createElement(IconStyled, { type: ExploreAll, size: ICON_SIZE.s }),
                buttonLabel)))));
}
